import {makeStyles} from '@material-ui/core'

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
  },
  button: {
    margin: theme.spacing(1),
  },
  group: {
    margin: theme.spacing(1, 0),
  },
}))

export default useStyles
